import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { ComponentStoreFactory } from '../../../../shared/store/common/component-store.factory';
import { ServiceGridItemObject } from '@it2go/types';
import { ServiceService } from '../../../../../services/service.service';
import { selectService } from '../../../store/service/service.selectors';
import { Observable } from 'rxjs';
import {
    ServicePatternGridObject,
} from '@libs/types/src/services/object-type/service/service-pattern.object';
import { map } from 'rxjs/operators';
import { ServicePatternType } from '@libs/types/src/services/enum/service-pattern-type.enum';

interface State {
    servicePatterns: ServicePatternGridObject | null,
}

const defaultState: State = {
    servicePatterns: null,
};

@Injectable()
export class ServicePatternsPageStore extends ComponentStoreFactory<State> {

    service$: Observable<ServiceGridItemObject | null> = this.globalStore!.select(selectService);
    documentsPatterns$ = this.data.servicePatterns$.pipe(map((it) => {
        if (!it) {
            return it;
        }
        return {
            ...it,
            items: it.items.filter((item: any) => item.type === ServicePatternType.DOCUMENT),
        };
    }));
    structurePatterns$ = this.data.servicePatterns$.pipe(map((it) => {
        if (!it) {
            return it;
        }
        return {
            ...it,
            items: it.items.filter((item: any) => item.type === ServicePatternType.STRUCTURE),
        };
    }));

    constructor() {
        super(defaultState, inject(Store), inject(ServiceService));
    }

}
